import React from "react";

interface ProjectCardProps {
  title: string;
  tech: string[];
  desc: string;
  link: string | null;
  animationClass?: string;
}

function ProjectCard(props: ProjectCardProps) {
  const { title, tech, desc, link, animationClass = "animate-fade-in" } = props;

  const cardClasses = [
    "opacity-0-start",
    animationClass,
    "block bg-bg-surface border border-border rounded-lg p-6",
    "flex flex-col gap-3.5 transition-all duration-200 relative overflow-hidden no-underline",
    link ? "cursor-pointer" : "cursor-default",
    "hover:border-brand hover:-translate-y-0.5 hover:shadow-card-hover",
  ].join(" ");

  const content = (
    <React.Fragment>
      <div className="absolute top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-brand to-accent opacity-60" />

      <div className="flex justify-between items-start">
        <h3 className="text-base font-semibold text-content">{title}</h3>
        {link ? (
          <span className="text-sm text-content-muted transition-colors duration-150">
            ↗
          </span>
        ) : null}
      </div>

      <p className="text-sm text-content-secondary leading-relaxed">{desc}</p>

      <div className="flex flex-wrap gap-1.5 mt-auto">
        {tech.map((t: string) => (
          <span
            key={t}
            className="text-2xs px-2.5 py-0.5 rounded-md bg-brand-dim text-brand font-mono font-medium"
          >
            {t}
          </span>
        ))}
      </div>
    </React.Fragment>
  );

  if (link) {
    return (
      <a href={link} target="_blank" rel="noopener noreferrer" className={cardClasses}>
        {content}
      </a>
    );
  }

  return <div className={cardClasses}>{content}</div>;
}

export default ProjectCard;